import {fileUploadPromise, formatProtectedAWSURL} from '../../utils/common';

/***
 * This is an adapter/hook (not a React component) that is used by CKEditor for custom upload handling. We perform
 * front-end uploads so we require this custom functionality.
 */
export default class CKEditorUploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }

    // When a user selects a file from the CKEditor UI this function will be entered.
    upload() {
        return this.loader.file.then(
            file => new Promise((resolve, reject) => {
                this._upload(resolve, reject, file);
            })
        );
    }

    // This is our upload handler. First get the signed resource keys and the upload the files.
    _upload(resolve, reject, file) {
        fileUploadPromise([file], {isProtected: true}).then(promiseList => {
            // An array is returned but we expect one file.
            promiseList.map(file => resolve({
                default: formatProtectedAWSURL(file)
            }));
        }).catch(() => {
            reject(`Couldn't upload file: ${file.name}.`);
        });
    }
}
